<template>
  <div v-if="persona && actividades">
    <h5 class="mb-4">Actividades de {{ persona.nombre }} {{ persona.apellidos }}</h5>

    <div class="form-group row">
      <b-dropdown id="dropdown-actividad" :text="actividadSeleccionada ? actividadSeleccionada.nombre : 'Seleccionar una actividad'">
        <b-dropdown-item v-for="actividad in actividades" :key="actividad.id" @click="seleccionarActividad(actividad)">{{ actividad.nombre }}</b-dropdown-item>
      </b-dropdown>
    </div>

    <template v-if="actividadSeleccionada">
    <form class="form-horizontal" id="form-participacion" action="" @submit.stop.prevent="enviarParticipaciones">

    <table class="table table-bordered mt-5">
      <tr>
        <th>Grupo</th>
        <th>Participación</th>
      </tr>
      <template v-for="periodo in actividadSeleccionada.periodos">
      <tr :key="periodo">
        <td colspan="2" class="text-center"><b>{{ periodo | mostrarMes }}</b></td>
      </tr>
      <tr v-for="g of actividadSeleccionada.grupos" :key="`${periodo}_${g.id}`">
        <td class="align-middle">{{ g.nombre }}</td>

        <td class="align-middle">
          <div class="form-check">
            <template v-for="(check, hora) of participacionActividad[periodo][g.id].horas">
            <span :key="`${periodo}_${g.id}_${hora}`">
            <input :name="`participacion:${periodo}:${g.id}:${hora}`" type="checkbox" class="form-check-input" v-model="participacionActividad[periodo][g.id].horas[hora]" @change="comprobarSeleccionLibre(periodo, g.id, hora)" />{{ hora == '0' ? 'Inscripción' : mostrarHoras([hora]) }}<br />
            </span>
            </template>
          </div>
        </td>

      </tr>
      </template>
    </table>

    <h5 class="pt-3">Cambios</h5>

    <table class="table">
      <thead>
        <tr>
          <th class="p-0"></th>
          <th class="p-1">Periodo</th>
          <th class="p-1">Grupo</th>
          <th class="p-1">Horas</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(c, index) in obtenerResumenCambios()" :key="index">
          <td v-if="c.tipo == 'alta'" class="align-middle text-center text-success p-0">▲</td>
          <td v-else-if="c.tipo == 'baja'" class="align-middle text-center text-danger p-0">▼</td>
          <td v-else-if="c.tipo == 'modificacion'" class="align-middle text-center text-warning p-0">⇄</td>
          <td v-else></td>
          <td class="align-middle px-1 py-2 p-md-2">{{ c.periodo }}</td>
          <td class="align-middle px-1 py-2 p-md-2">{{ c.grupo.nombre }}</td>
          <td class="align-middle px-1 py-2 p-md-2">
            <template v-if="'horas' in c && ! (c.horas.includes('0'))">{{ mostrarHoras(c.horas) }}</template>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-right"><button type="submit" class="btn btn-primary">Enviar</button></p>
    </form>

    </template>

  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo } from '../curso.js';
import { convertirHoras } from '../utils.js';

export default {
	name: 'AdminEditarParticipaciones',
	props: [ 'id_persona' ],
	data () {
		return {
			persona: null,
			actividades: null,
			actividadSeleccionada: null,
			participaciones: null,
			participacionActividad: null,
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.obtenerPersona();
		this.obtenerParticipaciones();
		this.obtenerActividades();
	},
	methods: {
		// FIXME: repetido. Extraer a librería común
		obtenerPersona() {
			api(`/personas/${this.id_persona}`)
				.then((data) => {
					this.persona = data.resultado;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		obtenerParticipaciones() {
			api(`/personas/${this.id_persona}/actividades/${this.curso.id_curso}`)
				.then((data) => {
					this.participaciones = data.resultado;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		// FIXME: repetido. Extraer a librería común
		obtenerActividades () {
			api(`/actividades/${this.curso.id_curso}`)
				.then((data) => {
					this.actividades = data.resultado;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		seleccionarActividad(actividad) {
			const participacionActividad = {};
			for (const periodo of actividad.periodos) {
				participacionActividad[periodo] = {};
				for (const grupo of actividad.grupos) {
					participacionActividad[periodo][grupo.id] = {
						horas: {},
						grupo: grupo,
						seleccion_libre: false,
					}
					if (grupo.horas && grupo.horas.length > 0) {
						if (grupo.seleccion_libre) {
							participacionActividad[periodo][grupo.id].seleccion_libre = true
						}
						for (const h of grupo.horas) {
							participacionActividad[periodo][grupo.id].horas[h] = false;
						}
					} else {
						participacionActividad[periodo][grupo.id].horas['0'] = false;
					}
				}
			}
			for (const part of this.participaciones) {
				if (part.id_actividad == actividad.id) {
					for (const periodo of part.periodos) {
						if (part.horas && part.horas[periodo]) {
							for (const h of part.horas[periodo]) {
								participacionActividad[periodo][part.id_grupo].horas[h] = true;
							}
						} else {
							participacionActividad[periodo][part.id_grupo].horas['0'] = true;
						}
					}
				}
			}
			this.participacionActividad = participacionActividad;
			// Esto no es lo más eficiente, pero así me evito depender de structuredClone o de lodash
			this.participacionOriginal = JSON.parse(JSON.stringify(participacionActividad));
			this.actividadSeleccionada = actividad;
		},
		comprobarSeleccionLibre(periodo, id_grupo, hora) {
			if (! this.participacionActividad[periodo][id_grupo].seleccion_libre) {
				const valor = this.participacionActividad[periodo][id_grupo].horas[hora];
				for (const h of Object.keys(this.participacionActividad[periodo][id_grupo].horas)) {
					this.participacionActividad[periodo][id_grupo].horas[h] = valor;
				}
			}
		},
		obtenerResumenCambios() {
			const cambios = [];
			for (const [periodo, grupos] of Object.entries(this.participacionActividad)) {
				for (const [id_grupo, datosGrupo] of Object.entries(grupos)) {
					const horasAntes = [];
					for (const [hora, activo] of Object.entries(this.participacionOriginal[periodo][id_grupo].horas)) {
						if (activo) {
							horasAntes.push(hora);
						}
					}
					const horasDespues = [];
					for (const [hora, activo] of Object.entries(datosGrupo.horas)) {
						if (activo) {
							horasDespues.push(hora);
						}
					}
					if (horasAntes.length == 0 && horasDespues.length > 0) {
						cambios.push({
							tipo: 'alta',
							periodo: periodo,
							grupo: datosGrupo.grupo,
							horas: horasDespues,
						});
					}
					if (horasAntes.length > 0 && horasDespues.length == 0) {
						cambios.push({
							tipo: 'baja',
							periodo: periodo,
							grupo: datosGrupo.grupo,
						});
					}
					if (horasAntes.length > 0 && horasDespues.length > 0) {
						const horasComunes = new Set([...horasAntes, ...horasDespues]);

						if (horasComunes.size != horasAntes.length || horasComunes.size != horasDespues.length) {
							cambios.push({
								tipo: 'modificacion',
								periodo: periodo,
								grupo: datosGrupo.grupo,
								horas: horasDespues,
								horas_antes: horasAntes,
							});
						}
                    }
				}
			}
			return cambios;
		},
		calcularCambiosEnvio() {
			const resumenCambios = this.obtenerResumenCambios();
			const cambios = [];
			for (const c of resumenCambios) {
				const cambio = {
					tipo: c.tipo,
					id_actividad: this.actividadSeleccionada.id,
					periodo: Number(c.periodo),
					id_grupo: c.grupo.id,
				};
				if (c.horas) {
					if (c.horas.length == 1 && c.horas[0] == "0") {
						// FIXME: Esto llega hasta aquí y es una auténtica guarrería, lo del "0" no puede llegar tan lejos
					} else {
						cambio.horas = c.horas;
					}
				}
				cambios.push(cambio);
			}
			return cambios;
		},
		enviarParticipaciones() {
			const cambios = this.calcularCambiosEnvio();
			api(`/personas/${this.id_persona}/actividades/${this.curso.id_curso}`, 'PUT', cambios)
				.then((data) => {
					if (data.resultado) {
						this.$router.push(`/admin/familia/${this.persona.id_familia}`);
					}
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		// TODO: Unificar con SociosFamilias y SociosEditarActividades. OJO, aquí no es un filtro
		mostrarHoras(listaHoras) {
			const convertidas = convertirHoras(listaHoras);
			return convertidas.join(', ');
		},
	},
	filters: {
		// TODO: obtenido de Balance - unificar
		mostrarMes(mes) {
			mes = mes.toString();
			return mes.substring(4, 6) + '/' + mes.substring(0, 4)
		},
	},
}
</script>
